import Vue from 'vue';
import Vuex from 'vuex';
import mediaqueries from './modules/mediaqueries';
import mainnavigation from './modules/mainnavigation';
import secondnavigation from './modules/secondnavigation';
import sticky from './modules/sticky';
import readmore from './modules/readmore';
import youtube from './modules/youtube';
import googlemap from './modules/googlemap';
import search from './modules/search';

import {
	filter,
	resetpassword,
	share,
	articles,
	overlay,
	signin,
} from './../../shared/store/modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    mediaqueries,
    mainnavigation,
    secondnavigation,
    overlay,
    sticky,
    readmore,
    youtube,
		googlemap,
		resetpassword,
		search,
		filter,
		share,
		articles,
		signin,
  }
})



// WEBPACK FOOTER //
// ./store/index.js